<div class="lefttrack">
  <div class="btn_tabs" id="topleftbtntabs" *ngIf="showTabs">
    <button id="objects_tab" (click)="this.openTabTracking('objects')" *ngIf="visibleComponents.indexOf('objects') >= 0">{{ 'Objects'| translate }}</button>
    <button id="geozones_tab" (click)="this.openTabTracking('geozones')" *ngIf="visibleComponents.indexOf('geozones') >= 0">{{ 'Geozones'| translate }}</button>
    <button id="drivers_tab" (click)="this.openTabTracking('drivers')" *ngIf="visibleComponents.indexOf('drivers') >= 0">{{ 'Drivers'| translate }}</button>
  </div>
  <div class="lefttrack-block">
    <div class="topleft" id="topleft">
      <app-devices-list [trackingMode]="trackingMode" *ngIf="visibleComponents.indexOf('objects') >= 0"></app-devices-list>
      <app-geozones-list *ngIf="visibleComponents.indexOf('geozones') >= 0"></app-geozones-list>
      <app-drivers-list *ngIf="visibleComponents.indexOf('drivers') >= 0"></app-drivers-list>
    </div>
    <div (mousedown)="splitterDown()" class="hor_splitter" id="hor_left_splitter"><span></span></div>
    <div class="bottomleft" id="bottomleft">
      <app-device-info [trackingMode]="trackingMode" *ngIf="visibleComponents.indexOf('objects') >= 0"></app-device-info>
      <app-geozone-info *ngIf="visibleComponents.indexOf('geozones') >= 0"></app-geozone-info>
      <app-driver-info [showDeviceInfo]="visibleComponents.indexOf('objects') < 0" *ngIf="visibleComponents.indexOf('drivers') >= 0"></app-driver-info>
    </div>
  </div>
</div>
